import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PartnerBlockRule} from '../../models/partner/partner-block-rule';

@Injectable({
  providedIn: 'root'
})
export class PartnerBlockRuleService extends AbstractModelService<PartnerBlockRule> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner-block-rule', PartnerBlockRule);
  }
}
